"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.Text = exports.SliderItem = exports.SliderContainer = exports.Price = exports.PrevArrowEl = exports.NextArrowEl = exports.ImageWrapper = exports.Image = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

var _transitions = require("@titelmedia/bricks-theme/lib/variables/transitions");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Arrow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 30px;\n  width: 30px;\n  background: rgba(255, 255, 255, 0.75);\n  transition: ", " all;\n  display: flex;\n  box-sizing: border-box;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: calc(50% - 45px);\n  transform: translate3d(0, -50%, 0);\n  z-index: 1;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.95);\n  }\n\n  svg {\n    max-width: 16px;\n  }\n  @media (min-width: 768px) {\n    top: calc(50% - 45px);\n    height: 40px;\n    width: 40px;\n  }\n"])), _transitions.TRANSITIONS.QUICK);

var NextArrowEl = (0, _styledComponents.default)(Arrow)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  right: 12px;\n\n  @media (min-width: 768px) {\n    right: 30px;\n  }\n"])));
exports.NextArrowEl = NextArrowEl;
var PrevArrowEl = (0, _styledComponents.default)(Arrow)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  left: 12px;\n\n  @media (min-width: 768px) {\n    left: 30px;\n  }\n\n  svg {\n    transform: rotate(180deg);\n  }\n"])));
exports.PrevArrowEl = PrevArrowEl;

var SliderItem = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 0px 6px 90px;\n\n  img {\n    max-width: 100%;\n  }\n\n  @media (min-width: 768px) {\n    padding: 0px 12px 90px;\n  }\n"])));

exports.SliderItem = SliderItem;

var ImageWrapper = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n"])));

exports.ImageWrapper = ImageWrapper;

var Image = _styledComponents.default.img(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  transform-origin: center center;\n"])));

exports.Image = Image;

var TextWrapper = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n"])));

exports.TextWrapper = TextWrapper;

var Text = _styledComponents.default.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-family: 'univers-roman';\n  font-size: 13px;\n  align-self: start;\n\n  @media (min-width: 768px) {\n    font-size: 18px;\n    max-width: 240px;\n  }\n"])));

exports.Text = Text;
var Price = (0, _styledComponents.default)(Text)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-family: 'univers-bold';\n"])));
exports.Price = Price;

var Container = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), (0, _layout.setContainer)({
  size: 'lg'
}));

exports.Container = Container;

var SliderContainer = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  padding-top: 60px;\n  padding-bottom: 60px;\n  position: relative;\n  margin: 0px -9px !important;\n  @media (min-width: 768px) {\n    margin: 0px -18px !important;\n  }\n"])));

exports.SliderContainer = SliderContainer;